module.exports = __webpack_public_path__ + "static/media/logo.avazanga.ac5377b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.avazanga.svg
// module id = 169
// module chunks = 0